import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import store from '@/store/store'

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/home/Index'),
      children: [
        {
          name: 'Home',
          path: '',
          component: () => import('@/views/home/Home')
        },
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/home/Login')
        }
      ]
    },
    {
      path: '/client',
      component: () => import('@/views/client/Index'),
      beforeEnter: (to, from, next) => {
        // todo: would be nice to use the store here, but the state is not available yet
        if (firebase.auth().currentUser) {
          next()
        } else {
          next({ path: '/login', query: { redirect: to.fullPath } })
        }
      },
      meta: { auth: true },
      children: [
        {
          name: 'レポート',
          path: '/client/report',
          component: () => import('@/views/client/Report')
        },
        {
          name: 'スケジュール',
          path: '/client/schedule',
          component: () => import('@/views/client/Schedule')
        },
        {
          name: 'コンテンツ',
          path: '/client/contents',
          component: () => import('@/views/client/Contents')
        },
        {
          name: 'プレイリスト',
          path: '/client/playlist',
          component: () => import('@/views/client/Playlist')
        },
        {
          name: '管理',
          path: '/client/devices',
          component: () => import('@/views/client/Devices')
        },
        {
          name: 'デバイス詳細',
          path: '/client/device/:id',
          component: () => import('@/views/client/Device')
        },
        {
          name: 'アドミン',
          path: '/client/admin',
          meta: { admin: true },
          component: () => import('@/views/client/Admin'),
          beforeEnter: (to, from, next) => {
            // user is logged in at this point, we only need to check the admin state
            if (store.getters['users/getActiveAdmin']) {
              next()
            } else {
              next({ path: '/client/report' })
            }
          }
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/home/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/home/Error')
        }
      ]
    }
  ]
})

export default router
